/**
 * Returns appState for Auth0 loginWithRedirect in PR preview environments.
 * Encodes the current preview's base path so the shared callback page
 * can redirect back to the correct PR preview after authentication.
 *
 * Returns an empty object in non-preview environments (prod, staging, local dev).
 */
export function getPreviewAppState(): { targetUrl?: string } {
  const basename = import.meta.env.VITE_ROUTER_BASENAME;
  if (!basename || basename === '/') return {};
  return { targetUrl: basename + '/' };
}
